import io from "socket.io-client";

const SOCKET_URL = "https://chat.119survey.org/";

const defaultOptions = {
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
};

/**
 * 채팅/동원자원용 소켓 생성.
 * 서버가 "Session ID unknown" (400) 반환 시 disconnect하여 새 핸드셰이크로 재연결되도록 함.
 * @param {object} [options] - io()에 넘길 추가 옵션
 * @returns {Socket}
 */
export function createChatSocket(options = {}) {
  const socket = io(SOCKET_URL, { ...defaultOptions, ...options });

  socket.on("connect_error", (err) => {
    const msg = (err && err.message) ? String(err.message) : "";
    const isSessionUnknown =
      msg.includes("Session ID unknown") ||
      msg.includes("session") ||
      msg.includes("400") ||
      (err && err.type === "TransportError");
    if (isSessionUnknown) {
      socket.disconnect();
    }
  });

  return socket;
}

export { SOCKET_URL };
